const basketballPrograms = [
  {
    id: 1,
    title: "Beginner – Ages 5-8",
    description:
      "ADS Basketball Beginner Clinics are designed for athletes ages 5–8 who are learning the fundamentals of basketball and developing confidence on the court. Training focuses on ball handling, passing, shooting, footwork, coordination, and overall basketball fundamentals.",
    ageGroup: "5-8",
    startDate: "2026-08-11",
    endDate: "2026-10-29",
    dates: "Tues & Thurs - Aug to Oct",
    duration: "3 Week Programs",
    time: "6:00PM - 7:00PM",
    singleDay: "$25",
    fullProgram: "$200",
    dropIn: "$35",
    location:
      "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
    locationUrl:
      "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",
    registration:
      "https://adssportscomplex.leagueapps.com/camps/5114183-ads-basketball-clinics---beginner---ages-5-8"
  },
  {
    id: 2,
    title: "Development – Ages 9-11",
    description:
      "ADS Basketball Development Clinics are designed for athletes ages 9–11 who are ready to build on their fundamentals and develop stronger basketball skills. Training will focus on ball handling, shooting, passing, footwork, defense, decision-making, and game situations.",
    ageGroup: "9-11",
    startDate: "2026-08-11",
    endDate: "2026-10-29",
    dates: "Tues & Thurs - Aug to Oct",
    duration: "3 Week Programs",
    time: "6:00PM - 7:00PM",
    singleDay: "$35",
    fullProgram: "$280",
    dropIn: "$45",
    location:
      "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
    locationUrl:
      "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",
    registration:
      "https://adssportscomplex.leagueapps.com/camps/5114304-ads-basketball-clinics--development--ages-9-11"
  },
  {
    id: 3,
    title: "Elite – Middle School & High School - Ages 12-18",
    description:
      "ADS Basketball Elite Clinics are designed for middle school and high school athletes who are ready for advanced training and higher-level competition. Sessions will focus on advanced skill development, game-speed decision-making, shooting, ball handling, defense, conditioning, and competitive situations.",
    ageGroup: "5-8",
    startDate: "2026-08-11",
    endDate: "2026-10-29",
    dates: "Tues & Thurs - Aug to Oct",
    duration: "3 Week Programs",
    time: "6:00PM - 7:00PM",
    singleDay: "$50",
    fullProgram: "$400",
    dropIn: "$60",
    location:
      "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
    locationUrl:
      "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",
    registration:
      "https://adssportscomplex.leagueapps.com/camps/5114370-ads-basketball-clinics--elite-middle--high-school--ages-12-18u"
  }
];

export default basketballPrograms;